import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import React from 'react';
import LocalCollapsibleError from '../LocalCollapsibleError';
const CollapsibleError = styled(LocalCollapsibleError)(({ theme })=>({
        padding: theme.spacing(2, 3, 3)
    }));
const FormError = (props)=>/*#__PURE__*/ React.createElement(Paper, {
        variant: "error"
    }, /*#__PURE__*/ React.createElement(CollapsibleError, props));
export default FormError;
